import { EVENT_SYSTEM } from './vocab.js';

// The Knowledge tab's chat is geo-play-intel's `live_event_knowledge` chat, scoped to one event. Intel only proposes:
// each card or task list comes back as a save envelope, and nothing is saved until someone clicks Save.

export const KNOWLEDGE_CHAT_PAGE = 'live_event_knowledge';

export const SNIPPET_CARD = 'knowledge_snippet';
export const TASKS_CARD = 'live_event_tasks';

const CARD_CATEGORIES = new Set([SNIPPET_CARD, TASKS_CARD]);

export const chatScope = (eventId) => ({ system: EVENT_SYSTEM, systemId: eventId, parents: [] });

// A save envelope from a finished tool step, or null. Only a step's `started` frame names its kind; the `completed`
// one carries just the id, the status and the details, so the envelope's own shape is the test.
export const saveEnvelope = (step) => {
    const raw = step?.details?.output;
    if (step?.status !== 'completed' || typeof raw !== 'string') return null;
    try {
        const env = JSON.parse(raw);
        return env?.ok && env.action === 'save' && CARD_CATEGORIES.has(env.category) && env.api_record ? env : null;
    } catch {
        return null;
    }
};

// Intel's notes delimit a title with straight quotes, so a title can't carry one.
const noteTitle = (t) => String(t || '').replace(/'/g, '’').slice(0, 200);

// Sent back on every later turn, so intel doesn't propose what was already saved or dismissed. A task list is noted
// one task at a time, the way intel checks it.
export const savedNotes = (env, id) => (env.category === SNIPPET_CARD
    ? [`[Saved upstream: knowledge_snippet '${noteTitle(env.api_record.title)}' → id=${id}]`]
    : env.api_record.tasks.map((t) => `[Saved upstream: live_event_task '${noteTitle(t.title)}' → id=${id}]`));

export const dismissedNotes = (env) => (env.category === SNIPPET_CARD
    ? [`[Dismissed: knowledge_snippet '${noteTitle(env.api_record.title)}']`]
    : env.api_record.tasks.map((t) => `[Dismissed: live_event_task '${noteTitle(t.title)}']`));
